import {PROJECT_ARTIFACT_PATHS} from './artifacts/artifactPaths';
import {PROJECT_JOB_PATHS} from './launch/launchPaths';
import {PROJECT_WEAVE_PATHS} from './weave/weavePaths';
import {
  PROJECT_BASE_PATH,
  PROJECT_WORKSPACE_PATHS,
} from './workspace/multiRunWorkspacePaths';
import {
  PROJECT_RUNS_REDIRECT_PATH,
  RUN_PATHS,
} from './workspace/singleRunWorkspacePaths';

export const HOME_PATH = '/home';

export const PROJECT_TAB_PATH = `${PROJECT_BASE_PATH}/:tab(overview|table|reportlist|sweeps|jobs|automations|artifacts)`;

export const PROJECT_OVERVIEW_SUBTABS_PATH = `${PROJECT_BASE_PATH}/:tab(overview)/:tabName(details|users|providers|weave)`;

export const PROJECT_PATHS = [
  ...PROJECT_WORKSPACE_PATHS,
  PROJECT_RUNS_REDIRECT_PATH,
  PROJECT_TAB_PATH,
  ...PROJECT_ARTIFACT_PATHS,
  PROJECT_OVERVIEW_SUBTABS_PATH,
  ...PROJECT_JOB_PATHS,
  ...PROJECT_WEAVE_PATHS,
  ...RUN_PATHS,
];

export const REDIRECT_PATH = `${PROJECT_BASE_PATH}/r/:redirectPath*`;

export const NO_ACCESS_PATH = '/no-access';

export const ANALYZE_MY_EXPERIMENTS_PATH = '/analyze_my_experiments';

// TODO: move these enums to a more appropriate location
export enum UTM_Source {
  FREE_PLAN = 'free-plan',
  APP_RESOURCE_CENTER = 'app-resource-center',
}

export enum UTM_Content {
  LEFT_NAV = 'left_nav',
}

export enum UTM_Medium {
  APP = 'app',
}

export enum UTM_Term {
  DOCS = 'docs',
  QUICKSTART = 'quickstart',
  FULLY_CONNECTED = 'fully-connected',
}
